import { cap } from '../../State'
import { translations } from '../../translations'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

/**
 * Intestazione riutilizzabile per i pannelli filtri Nora: icona, etichetta, badge conteggio e pulsante reset.
 * @param {Object} props - Proprietà del componente
 * @param {string} [props.icon='pi pi-filter'] - Classe CSS dell'icona PrimeIcons
 * @param {string} props.label - Etichetta visibile accanto all'icona
 * @param {number} [props.activeCount=0] - Numero di filtri attivi; se maggiore di zero mostra il badge
 * @param {boolean} [props.showReset=false] - Se true e onReset è fornito, mostra il pulsante reset
 * @param {Function} [props.onReset] - Callback invocata al click su "Reset filtri"
 * @param {string} [props.resetLabel] - Testo del pulsante reset
 * @param {string} [props.resetAriaLabel] - Etichetta ARIA del pulsante reset
 * @returns {import('react').JSX.Element} Header del pannello filtri
 */
export function FiltersPanelHead({
  icon = 'pi pi-filter',
  label,
  activeCount = 0,
  showReset = false,
  onReset,
  resetLabel = t.resetFilters,
  resetAriaLabel = t.removeAllFilters
}) {
  return (
    <div className="nora-filters__head">
      <div className="nora-filters__head-left">
        <i className={icon} style={{ fontSize: 14, color: 'var(--ink-700)' }} />
        <span className="nora-filters__label">{label}</span>
        {activeCount > 0 && (
          <span className="nora-filters__badge">
            {activeCount} {activeCount === 1 ? t.activeFilterOne : t.activeFilterMany}
          </span>
        )}
      </div>
      {showReset && onReset && (
        <button
          type="button"
          className="nora-filters__reset"
          onClick={onReset}
          aria-label={resetAriaLabel}
          tabIndex={0}
        >
          <i className="pi pi-times" style={{ fontSize: 11 }} />
          {resetLabel}
        </button>
      )}
    </div>
  )
}
